import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {BusinessListComponent} from './business-list.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.businessList.pageInRouting,
    data: {data: PAGES_AND_PATHS.businessList},
    component: BusinessListComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./business-list.module').then(m => m.BusinessListModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessListRoutingModule { }
